








































import Vue from 'vue';
import Card from '@/components/Argon/Cards/Card.vue';
import { DropdownMenu, Dropdown } from 'element-ui';
export default Vue.extend({
  name: 'ResumenCard',
  components: {
    Card,
    DropdownMenu,
    Dropdown,
  },
  data: () => ({
    // eslint-disable-next-line
    logo: 'data:image/png;base64,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',
  }),
  props: {
    name: {
      type: String,
      required: true,
    },
    total: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  methods: {
    newTransfer() {
      this.$emit('open');
    },
    detailTransfer() {
      this.$emit('detail');
    },
  },
});
